import type { ComponentMultiStyleConfig } from '@chakra-ui/theme';
import { Colors, TextStyles, Space, Radii, Shadows, FontWeights } from '../../types';

export const Menu: ComponentMultiStyleConfig = {
  baseStyle: {
    list: {
      bg: Colors.SURFACE_ELEVATED,
      borderRadius: Radii.XL,
      boxShadow: Shadows.LG,
      p: Space['2XS'],
      border: 'none',
      outline: '1px solid',
      outlineColor: Colors.BORDER_ELEVATED,
    },
    item: {
      direction: 'horizontal',
      px: Space.SM,
      py: Space.XS,
      bg: Colors.TRANSPARENT,
      borderRadius: Radii.LG,
      color: Colors.TEXT_EMPHASIS,
      gap: Space.XS,
      '&': { apply: `textStyles.${TextStyles.UI_DEFAULT}`, fontWeight: FontWeights.REGULAR },
      '.chakra-menu__icon-wrapper': {
        fontSize: '1em',
        me: 0,
        color: Colors.ICON_DEFAULT,
      },
      _hover: {
        '&:not[disabled]': {
          bg: Colors.SURFACE_ELEVATED_HOVER,
          color: Colors.TEXT_EMPHASIS,
        },
      },
      _focus: {
        bg: Colors.SURFACE_ELEVATED_HOVER,
        color: Colors.TEXT_EMPHASIS,
      },
      _focusVisible: {
        boxShadow: Shadows.OUTLINE,
      },
      _active: {
        bg: Colors.SURFACE_ELEVATED_ACTIVE,
        color: Colors.TEXT_EMPHASIS,
      },
      small: {
        color: Colors.TEXT_MUTED,
        textStyle: TextStyles.P3,
      },
    },
    groupTitle: {
      mb: Space['2XS'],
      mx: Space.SM,
      gap: Space.XS,
      color: Colors.TEXT_SUBDUED,
      '&': { apply: `textStyles.${TextStyles.P3}` },
    },
    divider: {
      borderColor: Colors.BORDER_DEFAULT,
      mx: -1,
    },
  },
  parts: [],
};
